import type { Product } from '@labrav/common'
import { useSelector } from '../../../store/hooks'

export const useActiveProducts = () => {
  const activeProducts = useSelector<Product[] | string[]>(
    state => state.AccountData.user.partnerData?.activeProducts || []
  )
  return activeProducts
}
